<script setup lang="ts">
import FormGroup from "@/stories/form/FormGroup/FormGroup.vue";

interface Props {
  isActive?: boolean;
}

withDefaults(defineProps<Props>(), {
  isActive: true,
});
</script>

<template>
  <div :class="{ 'big-desktop:w-1/2': isActive }">
    <FormGroup>
      <slot></slot>
    </FormGroup>
  </div>
</template>
